import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'EQ 3 – Social Awareness / Empathy',
  slug: 'eq-3-social-awareness-empathy',
  category: 'EQ',
  date: '2025-05-16',
  image: '',
  excerpt: 'Empathy goes a long way to working with others.',
  body: `Social Awareness is the ability to read other people, understand what's making them tick. Empathy is part of social awareness. It requires setting aside assumptions about what the other person thinks and really listening. Try some of these:

1. Contribute. Be of service. This is the best way to approach others. When your aim is to be of service, you can't lose. If your timing is off, your intention is still there. Be of service with no expectation or demand for reciprocity.
2. Use people's name – they like to hear it.
3. Body language. Watch people's smile. Shoulders and posture. Eye contact.
4. Consider timing. Look for an opening by considering the needs of the other person.
5. Plan ahead. When going to a social or business meeting, be prepared. Bring something to the table to share. Information. A joke. Food.
6. Be here now. Be present.
7. Listen to the other person, don't just wait to talk.
8. Take fifteen minutes to get to know where you are. Take a visual tour of the room you're in. It'll help you be present.
9. Now that you see the room, READ the room. What is the emotional atmosphere? Are people happy? Excited? Afraid? Now, how might you contribute, using this information?
10. Try the alternate golden rule. Don't treat people how YOU want to be treated. Treat them how THEY want to be treated. That means you need to take the time to get to know them.
11. Test your assumptions. Always ask, "am I understanding you correctly?…"
12. Empathize. Try to put yourself in the other person's shoes. How would THIS make him or her feel?
13. Ask a friend. Ask someone who KNOWS you well. What are my strengths? Weaknesses? They might see some things you don't.`,
}

export default post
